import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

// services
import { RaptorDataService } from '@campfire-nx/raptor/lib/services/raptor-data.service';
import { RaptorPriceService } from '@campfire-nx/raptor/lib/services/raptor-price.service';
import { RaptorFormService } from '@campfire-nx/raptor/lib/services/raptor-form.service';
import { RaptorStepService } from '@campfire-nx/raptor/lib/services/raptor-step.service';
import { RaptorStepDataService } from '@campfire-nx/raptor/lib/services/raptor-step-data.service';

@Component({
  selector: 'open-raptor-price-card',
  templateUrl: './raptor-price-card.component.html',
  styleUrls: ['./raptor-price-card.component.scss']
})
export class RaptorPriceCardComponent implements OnInit {
  @Input() componentDetails: any;
  @Input() form!: FormGroup;
  formData: any;
  covers: any;
  cards: any;
  frequencyControl!: any;
  coverLevelControl: any;
  coverTypeControl: any;
  productSlugControl: any;
  currency!: string;
  currencySymbol!: string;
  coverLevel!: any;
  coverType!: any;

  constructor(
    public raptorStepService: RaptorStepService,
    public raptorPriceService: RaptorPriceService,
    public raptorDataService: RaptorDataService,
    private raptorStepDataService: RaptorStepDataService,
    private raptorFormService: RaptorFormService
  ) {}


  ngOnInit(): void {
    this.formData = this.raptorStepDataService.get();
    this.covers = this.formData.covers;
    this.coverLevelControl = this.form?.get('cover_level');
    this.coverTypeControl = this.form?.get('cover_type');
    this.productSlugControl = this.form?.get('product_slug');
    this.frequencyControl = this.form?.get('frequency');
    this.cards = this.componentDetails?.settings?.cards;
    this.currency = this.formData?.product?.country?.currency;
    this.currencySymbol = this.formData?.product?.country?.currency_symbol;
    this.coverLevel = this.formData?.data?.cover_level;
    this.coverType = this.formData?.data?.cover_type;
    let totalMatchedCovers = 0;

    // Loop through the cards and add the corresponding cover
    // to its definition.
    if (this.cards && this.cards.length > 0 && this.covers) {
      for (const card of this.cards) {
        const matchedCover = this.covers.find((cover:any) => (
          card.productSlug === cover?.cover.product_slug &&
          card.coverLevel === cover?.cover.cover_level &&
          card.coverType === cover?.cover.cover_type
        ));

        if (matchedCover) {
          card.cover = matchedCover;
          totalMatchedCovers = totalMatchedCovers + 1;
        }
      }
    }

    if ( totalMatchedCovers === 1) {
      // If there is only one cover matched and it has no cta,
      // then select it automatically.
      const ctaDisabled = this.cards.find((card:any) => card.cta.enabled === false);
      if (ctaDisabled) {
        this.selectCover(ctaDisabled);
      }
    }

  }

  get frequency() {
    return this.frequencyControl?.value || this.formData?.data?.frequency;
  }
  
  selectCover(cover: any) {
    if (this.coverLevelControl) {
      this.coverLevelControl.setValue(cover.coverLevel, { emitEvent: false });
    }
    if (this.productSlugControl) {
      this.productSlugControl.setValue(cover.productSlug, { emitEvent: false });
    }
  }

  submitCover(cover: any) {
    this.selectCover(cover);
    this.raptorFormService.submit(this.form, this.formData);
  }
}